function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M6.677 5.429a3.827 3.827 0 011.867-3.445 3.82 3.82 0 013.919 0 3.805 3.805 0 011.86 3.445v1.464h1.415V5.429a5.241 5.241 0 00-2.56-4.697A5.248 5.248 0 005.9 2.727a5.234 5.234 0 00-.638 2.702v1.464h1.414V5.429z",
  fill: "#7F63FF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.001 6.893H2.999A3.006 3.006 0 000 9.899V22.63a3.02 3.02 0 001.85 2.777c.364.152.754.23 1.149.23h15.002a2.992 2.992 0 002.999-3V9.906a3.006 3.006 0 00-.863-2.122 3.021 3.021 0 00-2.136-.891zm-6.79 10.383v2.447H9.796v-2.447a2.25 2.25 0 01-1.513-2.49 2.25 2.25 0 012.22-1.874 2.243 2.243 0 012.222 1.888 2.235 2.235 0 01-1.514 2.49v-.014z",
  fill: "#7F63FF"
});

function SvgVerificationStatus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 21 26",
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "632eacaf9dee1a16442de8af2b921823.svg";
export { SvgVerificationStatus as ReactComponent };